import './utils/jquery-extensions';
import * as commonModules from './components/common';
import flyinscrolling from './flyins/flyinscrolling';
import searchinputfield from './search/searchinputfield';
import countries from './components/country-selection/countries';
import minicart from './components/header/minicart';
import miniwishlist from './components/header/miniwishlist';
import wishlist from './pages/wishlist';
import sustainability from './pages/sustainability';
import {init as initFlyin} from './flyins/flyin';
import inputfields from './utils/inputfields';
import scrolledpage from './components/scrolledpage';
import smoothscrolling from './utils/smoothscrolling';
import validator from './utils/validator';
import {init as initLegalTerms} from './components/legalterms';
import {init as initNewsletterfooter} from './components/footer/newsletterfooter';
import showpassword from './utils/showpassword';
import emojiremove from './utils/emojiremove';
import videovimeo from './utils/videovimeo';
import lazyload from './utils/lazyload';
import breadcrumbs from './components/breadcrumbs';
import distributionmodules from './components/distributionmodules';
import {init as pageSearchInit} from './pages/search';
import carousel from './components/carousel';
import cartoverlay from './components/checkout/cartoverlay';
import crossSell from './components/cross-sell';
import tracking from './components/tracking/tracking';
import ConstructorIOSearch from './constructor-io/search';
import {initialRender as renderConstructorResults} from './constructor-io/helpers/search';
import initQuiz from './constructor-io/helpers/quiz';
import {NewsletterPopup} from './flyins/newsletterpopup';
import {init as initFilters2019} from './filters2019/main';
import webVitals from './components/web-vitals';
import {initUniversalRecommendations} from './constructor-io/helpers/recommendations';
import klaviyoListeners from './klaviyo/klaviyoListeners';

// initialize app
$(async () => {
    if (ConstructorIOSearch.isEnabled) {
        window.addEventListener('plp.updateproductlisting', initFilters2019, {once: true});
        await renderConstructorResults(ConstructorIOSearch);
    } else {
        initFilters2019();
    }

    commonModules.initializeDom();
    commonModules.initializeEvents();
    commonModules.init();
    commonModules.initCookiePrivacy();

    breadcrumbs.init();
    emojiremove.init();
    lazyload.init();
    countries.init();
    scrolledpage.init('clp');
    smoothscrolling.init();
    flyinscrolling.init();
    inputfields.init();
    minicart.init();
    miniwishlist.init();
    if (!ConstructorIOSearch.isEnabled) {
        wishlist.initProductTilesWishlist();
    }
    initFlyin();
    sustainability.init();
    searchinputfield.init();
    validator.init();
    initNewsletterfooter();
    NewsletterPopup.initCLPandPDP();
    showpassword.init();
    videovimeo.init();
    distributionmodules.init();
    initLegalTerms();
    commonModules.changeMainWrapperPadding();
    initQuiz();
    webVitals.init();
    klaviyoListeners.init();

    if (ConstructorIOSearch.isEnabled) {
        tracking.plpLoad('constructor');
    } else {
        tracking.plpLoad('sfcc');
    }

    initUniversalRecommendations('category');

    // execute page specific initializations
    pageSearchInit();

    // needed for Demandware Predictive Recommendations
    window.dwapp = {
        /**
         * Reports recommendations
         */
        reportRecommendationLoad: () => {
            lazyload.init();
            carousel.init();
            crossSell.init();
        },

        /**
         * Reports cart recommendations
         */
        reportCartRecommendationLoad: () => {
            const is1774 = $('.landing-1774').length > 0;
            lazyload.init();
            if (is1774) {
                carousel.init();
            } else {
                cartoverlay.slickRecomm();
            }
            crossSell.init();
        }
    };
});
